export default __webpack_public_path__ + "static/media/IconDesc_Beacon.256.988c7d23.png";